export const buildAndPriceClass = 'remote-build-price';
